var map = {
	"./Messages.jpg": 353,
	"./Messages.png": 141,
	"./book.png": 142,
	"./box.png": 143,
	"./chat.png": 144,
	"./chat_01.png": 354,
	"./chat_02.png": 355,
	"./chat_icon.png": 356,
	"./cloud.png": 145,
	"./dashboard.png": 357,
	"./dot.png": 358,
	"./get_started_bg.png": 359,
	"./john.png": 146,
	"./left_leaf.png": 147,
	"./live_chat.png": 148,
	"./mobile.png": 149,
	"./panguin_img_one.png": 150,
	"./panguin_img_three.png": 151,
	"./panguin_img_two.png": 152,
	"./pluse.png": 153,
	"./richard.png": 154,
	"./right_leaf.png": 155,
	"./skyp_1.png": 360,
	"./skyp_2.png": 361,
	"./support_dashboard.jpg": 362,
	"./triangle.png": 156,
	"./video_icon.png": 363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75;